// ================================================================================
// validation.js
// フォームのバリデーション用のファイル
// ================================================================================

// NOTE: wp_footer 側で実装





